import { FC, useState } from 'react';
import { Modal } from 'antd';
import ReactCrop, { Crop } from 'react-image-crop';

import { DialogTitle } from '~src/shared/dialogs/shared.sc';
import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';

import {
  ErrorMessage,
  ImageCropperButtonContainer,
  ModalImage,
  ModalImageContainer,
  SaveButton,
} from './imageUploader.sc';
import {useTranslation} from "react-i18next";

interface Props {
  show: boolean;
  onHide: () => void;
  titleKey: string;
  saveImagetoBackend: (crops: Crop, callback: () => void) => void;
  image: string | ArrayBuffer | null;
}

const ImageCropperModal: FC<Props> = (props) => {
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState(false);
  const [cropStatus, setCropStatus] = useState<undefined | Crop>({
    unit: '%',
    x: 0,
    y: 0,
    aspect: 1,
    width: 50,
  });

  const { t } = useTranslation();

  const onHide = () => {
    props.onHide();
  };

  const crop = (__: Crop, percentCrop: Crop | undefined) => {
    setCropStatus(percentCrop);
  };

  const saveThisImage = () => {
    setSaveLoading(true);
    if (cropStatus) {
      props.saveImagetoBackend(cropStatus, (errorResp?: string) => {
        if (errorResp) {
          setError(!!errorResp);
        } else {
          props.onHide();
          setError(false);
        }
        setSaveLoading(false);
      });
    }
  };

  return (
    <Modal
      open={props.show}
      onCancel={onHide}
      footer={null}
      cancelText="cancel"
      okText="ok"
      closable
      title={
        <DialogTitle $color="baseBlue">
          {props.titleKey && <span data-translation={props.titleKey}>{t(props.titleKey)}</span>}
        </DialogTitle>
      }
    >
      <ModalImageContainer>
        <ModalImage>
          {props.image && typeof props.image === 'string' && (
            <ReactCrop
              src={props.image}
              crop={cropStatus}
              onChange={crop}
              imageStyle={{ maxWidth: '100%', maxHeight: '26rem' }}
              style={{ maxWidth: '100%', maxHeight: '26rem' }}
            />
          )}
        </ModalImage>
        <ImageCropperButtonContainer>
          <SecondaryButton onClick={onHide}>
            <span data-translation="x.button.cancel">{t('x.button.cancel')}</span>
          </SecondaryButton>
          <SaveButton>
            <PrimaryButtonLoading isLoading={saveLoading} onClick={saveThisImage}>
              <span data-translation="x.button.upload">{t('x.button.upload')}</span>
            </PrimaryButtonLoading>
          </SaveButton>
        </ImageCropperButtonContainer>
        {error && <ErrorMessage>{t('x.imageupload.modal.error_message')}</ErrorMessage>}
      </ModalImageContainer>
    </Modal>
  );
};

export default ImageCropperModal;
